import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(11.000000, 5.000000)">
        <polygon
          points="66.04 28.08 62.24 34.66 47.11 60.87 43.3 67.46 39.5 74.05 35.7 67.46 39.5 60.87 43.3 54.27 54.63 34.66 47.02 34.66 39.5 47.68 31.98 34.66 24.37 34.66 35.7 54.27 31.89 60.87 16.76 34.66 12.96 28.08 66.04 28.08"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
